import css from 'styled-jsx/css';
import { colors } from '../../theme/theme';

const style = css`
  .timeline-item-wrapper {
    display: flex;
  }
  .bar {
    width: 18px;
  }
  .first.bar {
    height: 16px;
    border-right: 1px solid ${colors.border};
  }
  .second.bar {
    height: calc(100% - 48px);
    border-right: 1px solid ${colors.border};
  }
  .first.bar.hidden,
  .second.bar.hidden {
    border-right: none;
  }
  .icon-wrapper {
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .right {
    padding-top: 16px;
  }
  .title {
    display: flex;
    align-items: center;
    height: 32px;
    margin: 0;
    font-family: AvenirNext;
    font-size: 16px;
    color: #313131;
  }
  .date-time {
    color: #9f9f9f;
    margin-left: 8px;
    font-family: AvenirNext;
    font-size: 14px;
    line-height: 18px;
  }
  .body {
    margin-bottom: 16px;
  }
`;

export default style;
